// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4n-0";
export var orangeButton = "_4n-1";